import { FETCH_APPOINTMENT } from "./index";

export const setAppointmentData = (payload) => {
  return {
    type: FETCH_APPOINTMENT,
    payload: payload,
  };
};
